// extracted by mini-css-extract-plugin
export const header = "m_w";
export const nav = "m_x";